import { Col, Form, Row, Modal } from "react-bootstrap";
import { useLanguage, useToggle } from "hooks";
import CollapseList from "./CollapseList";

const SideFilter = ({
  subItemTitleSelector = "name",
  title,
  filters,
  CollapseProps,
  type,
}) => {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const [show, toggleShow] = useToggle();

  return (
    <>
      <Row className="align-items-center mb-4 ">
        <Col xl={10} lg={10} md={10} sm={10} xs={10}>
          <h2 className="fw-medium text-primary"> {title} </h2>
        </Col>
        <Col
          xl={2}
          lg={2}
          md={2}
          sm={2}
          xs={2}
          className="d-flex justify-content-end d-block d-lg-none"
        >
          <button className="btn btn-outline-light4" onClick={toggleShow}>
            {language.filter}
          </button>
        </Col>
      </Row>

      <Row className="d-none d-lg-flex">
        <Col xs={12}>
          {filters.getAllFilters().map((item, index) => (
            <CollapseList
              key={index}
              className="svg-fill-black mb-4 "
              titleClasses="text-black"
              title={item.name}
              {...CollapseProps}
            >
              {item.values.map((subItem, subIndex) => (
                <Form.Check
                  className="list-item fw-normal d-flex gap-3 align-items-center text-black"
                  key={subIndex}
                  type={"checkbox"}
                  id={`checkbox-${index}-${subIndex}`}
                  label={subItem[subItemTitleSelector]}
                  onChange={() =>
                    filters.handleToggleFilterValue(item.key, subItem.id)
                  }
                  checked={
                    filters.selectedFilters.filter(
                      (f) => f.key === item.key && f.values.includes(subItem.id)
                    ).length > 0
                  }
                />
              ))}
            </CollapseList>
          ))}
        </Col>
      </Row>

      <Modal
        show={show}
        onHide={toggleShow}
        animation={true}
        fullscreen={true}
        centered
        className="bg-white "
      >
        <Modal.Header className="" closeButton>
          <Modal.Title className="col-10">{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body className="vh-100 px-4 py-5 ">
          {filters.getAllFilters().map((item, index) => (
            <CollapseList
              key={index}
              title={item.name}
              className="svg-fill-black mb-4 "
              titleClasses="text-black"
            >
              <div className="d-flex flex-wrap gap-2">
                {item.values.map((subItem, subIndex) => (
                  <div key={subIndex} className="list-item d-block mb-2">
                    <input
                      type={type}
                      className="btn-check rounded-3"
                      id={`checkbox-${index}-${subIndex}`}
                      autoComplete="off"
                      checked={
                        filters.selectedFilters.filter(
                          (f) =>
                            f.key === item.key && f.values.includes(subItem.id)
                        ).length > 0
                      }
                      onChange={() =>
                        filters.handleToggleFilterValue(item.key, subItem.id)
                      }
                    />
                    <label
                      role="button"
                      htmlFor={`checkbox-${index}-${subIndex}`}
                      className="btn-label py-2 px-3 rounded-5"
                    >
                      <p className="fw-normal">{subItem.name}</p>
                    </label>
                  </div>
                ))}
              </div>
            </CollapseList>
          ))}
        </Modal.Body>

        <Modal.Footer className="bottom-0 position-fixed w-100 bg-white">
          <button className="btn btn-primary w-100" onClick={toggleShow}>
            {language.applyFilters}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default SideFilter;
